import Placeholder from '~/client/shared/LazyLoad/Placeholder';

const RowPlaceholder = () => (
  <div className="mx-0 my-4 grid grid-cols-[1rem_auto_1.75rem] gap-3">
    <Placeholder width="1rem" height="1rem" />
    <Placeholder width="100%" />
  </div>
);

export default RowPlaceholder;
